module.exports = __webpack_public_path__ + "media/images/mypage/icon/red/ico_alert-f9add6333a89f2a3740820910551ccf4.svg";